// Maps a booking status to its BookingTag color
export const STATUS_TAG_COLOR = {
  upcoming: "blue",
  completed: "green",
  canceled: "red"
}
